var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIpad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10847",
    "data-name": "Rectangle 10847",
    width: 131.998,
    height: 117.991,
    fill: "#ccc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7082",
    "data-name": "Groupe 7082",
    transform: "translate(-528 -475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "anim-vitale",
    d: "M100,199A99,99,0,1,0,1,100,99,99,0,0,0,100,199Zm0,1A100,100,0,1,0,0,100,100,100,0,0,0,100,200Z",
    transform: "translate(528 475)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6906",
    "data-name": "Groupe 6906",
    transform: "translate(562.001 516.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6905",
    "data-name": "Groupe 6905",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3755",
    "data-name": "Trac\\xE9 3755",
    d: "M52.383,0a4,4,0,0,1,2.589.951l76.291,64.828a4,4,0,0,1-.185,6.242l-51.307,38.6a4,4,0,0,1-5.175-.313L1.306,39.729a4,4,0,0,1,.616-6.248L50.218.638l.019-.013A3.992,3.992,0,0,1,52.383,0ZM77.368,109.926a2.478,2.478,0,0,0,1.5-.5l51.307-38.6a2.5,2.5,0,0,0,.115-3.9L54,2.095a2.5,2.5,0,0,0-2.95-.21L2.756,34.727l-.019.013a2.5,2.5,0,0,0-.391,3.908l73.29,70.581A2.486,2.486,0,0,0,77.368,109.926Z",
    transform: "translate(-0.354 -0.32)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3756",
    "data-name": "Trac\\xE9 3756",
    d: "M79.56,106.842a.749.749,0,0,1-.522-.211l-59.2-57.34a.75.75,0,0,1,.1-1.158L65.337,17.1a.75.75,0,0,1,.911.049L127.364,69.4a.75.75,0,0,1-.032,1.166L80.015,106.688A.748.748,0,0,1,79.56,106.842ZM21.537,48.852,79.618,105.1l46.066-35.166L65.709,18.66Z",
    transform: "translate(-8.692 -7.566)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    d: "M4.27-.75A5.78,5.78,0,0,1,7.74.344,3.6,3.6,0,0,1,9.289,3.219,3.6,3.6,0,0,1,7.74,6.094,5.78,5.78,0,0,1,4.27,7.188,5.78,5.78,0,0,1,.8,6.094,3.6,3.6,0,0,1-.75,3.219,3.6,3.6,0,0,1,.8.344,5.78,5.78,0,0,1,4.27-.75Zm0,6.438A4.275,4.275,0,0,0,6.837,4.9a2.136,2.136,0,0,0,.952-1.677,2.136,2.136,0,0,0-.952-1.677A4.275,4.275,0,0,0,4.27.75,4.275,4.275,0,0,0,1.7,1.542,2.136,2.136,0,0,0,.75,3.219,2.136,2.136,0,0,0,1.7,4.9,4.275,4.275,0,0,0,4.27,5.688Z",
    transform: "translate(98.369 80.426)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3757",
    "data-name": "Trac\\xE9 3757",
    d: "M77.315,145.362q-.112,0-.223-.006a4,4,0,0,1-2.55-1.113l0,0L1.222,72.446A4.021,4.021,0,0,1,0,69.568s0-.005,0-.008l.065-6.221a.75.75,0,0,1,1.5.016L1.5,69.571a2.514,2.514,0,0,0,.765,1.8l0,0,73.317,71.8a2.484,2.484,0,0,0,3.25.178l51.326-39.294a2.514,2.514,0,0,0,.976-1.981l-.03-6.344a.75.75,0,0,1,1.5-.007l.03,6.348a4.025,4.025,0,0,1-1.563,3.175L79.749,144.536A4,4,0,0,1,77.315,145.362Z",
    transform: "translate(-0.32 -27.052)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3758",
    "data-name": "Trac\\xE9 3758",
    d: "M60.678,32.774c.013.308.4.541.876.523s.843-.285.83-.592-.4-.541-.876-.523-.843.285-.83.592",
    transform: "translate(-25.912 -13.742)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3759",
    "data-name": "Trac\\xE9 3759",
    d: "M54.364,35.669l-5.987,4.18a.636.636,0,0,1-.731-1.041l5.956-4.2a.636.636,0,0,1,.709-.016l.031.02a.636.636,0,0,1,.021,1.057",
    transform: "translate(-20.232 -14.729)",
    fill: "#ccc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpad);
export default __webpack_public_path__ + "static/media/ipad.0fcc7927d40ef0739098e3a268a52b27.svg";
export { ForwardRef as ReactComponent };